import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./TeamColorsCircle.css";
export var TeamColorsCircle = function (_a) {
    var color1 = _a.color1, color2 = _a.color2;
    return (_jsxs("div", { className: "circle-container", children: [_jsx("div", { className: "circle-half circle-left", style: { backgroundColor: color1 } }), _jsx("div", { className: "circle-half circle-right", style: { backgroundColor: color2 } })] }));
};
